import React, { Component } from 'react';

import style from './airlineRepModal.module.css';
import commonStyles from '../../../common/common.module.css';

import {Paper, Button, Grid, withStyles, createStyles, Theme, Select, FormControl, DialogTitle, IconButton, Dialog, DialogContent, Tooltip, OutlinedInput } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AddBoxIcon from "@material-ui/icons/AddBox";

import { DeleteOutline } from '@material-ui/icons';
import MaterialTable from 'material-table';
import userManagementReqHandler from '../../../../api/userManagementRemote';
import ResponseError from '../../../../models/ResponseError';
import { receiveError, receiveSuccess } from '../../../../store/actions/notificationAction';
import { connect } from 'react-redux';
import AirlineType from '../../../../models/AirlineType';

interface AirlineRepModalProps {
  airlineValue: string;
  modalOpen: boolean;
  handleClose: () => void;
  handleChange: (e: any) => void;
  editUser: () => void;
  receiveSuccess: Function;
  receiveError: Function;
  userAirlines: {
    userId: number;
    opened: boolean;
    type: editUserType;
  };
  classes: any;
};

interface AirlineRepModalState {
  userAirlines: AirlineType[];
  airlines: AirlineType[];
};

type editUserType =  "create" | "update" | "reactivate";

const styles = (theme: Theme) =>

  createStyles({
    formField: {
      height: 40,
      width: '100%'
    },
    rowContainer: {
      paddingRight: 20,
    },
    marginTop10: {
      marginTop: 10
    }
  });

class AirlineRepModal extends Component <AirlineRepModalProps, AirlineRepModalState> {

  state = {
    userAirlines: [],
    airlines: []
  }

  componentDidMount() {
    this.getAirlinesForUser();
    this.getGhaAirlines();
  }

  getGhaAirlines = () => {
    userManagementReqHandler.getAirlines().then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }

  deleteUserAirline = (airlineId: number) => {
    userManagementReqHandler.deleteAirline(airlineId, this.props.userAirlines.userId).then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ userAirlines: airlines });
      }
    });
  } 

  addAirlineToUser = () => {
    userManagementReqHandler.addAirline(parseInt(this.props.airlineValue), this.props.userAirlines.userId).then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ userAirlines: airlines });
      }
    })
  }

  getAirlinesForUser = () => {
    userManagementReqHandler.getAirlinesForUser(this.props.userAirlines.userId).then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ userAirlines: airlines });
      }
    });
  }

  render() {

  return (
    <Dialog
      open={this.props.modalOpen}
      onClose={this.props.handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth={'sm'}
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title" >
        <div className={style.dialogTitle}>
          <span className={style.name}>Handled Carriers</span>
          <IconButton aria-label="Close" className={style.close} onClick={this.props.handleClose}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div>
          <Grid container className={this.props.classes.rowContainer}>
          
            <Grid item xs={5}>
            <FormControl className={this.props.classes.formField}>
              <label className={ commonStyles.inputLabel }> Carrier </label>
              <Select
                native
                id="airlineValue"
                name="airlineValue"
                onChange={this.props.handleChange}
                className={this.props.classes.formField}
                value={this.props.airlineValue}
                input={ <OutlinedInput labelWidth={ 0 }  /> }
              >
                <option value=''/>
                { this.state.airlines.map((airline: AirlineType) => {
                    return (<option value={ airline.id } key={ airline.id }>{ airline.name + '-' + airline.awb_code }</option>);
                  })
                }
              </Select>
            </FormControl>
            </Grid>

            <Grid item xs={2} className={ style.addBtn }>
              <IconButton
                aria-label="Filter"
                className={ style.button }
                disabled={ !this.props.airlineValue }
                onClick={this.addAirlineToUser}
              >
              <AddBoxIcon
                color="primary"
                className={ style.materialIcon }
              />
            </IconButton>
            </Grid>
            
          </Grid>
        </div>

        <div className={ `${ commonStyles.wrapper } ${ style.tableWrapper }` }>
          <MaterialTable
          
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            columns={[
              {
                title: 'Extended Airline', field: '', render: (airline: any) => {
                  return `${airline.awb_code}`;
                }
              },
              {
                title: 'Name', field: '', render: (airline: any) => {
                  return `${airline.name}`;
                }
              },
              {
                title: '', headerStyle: { textAlign: 'center' },
                render: (airline: any) => {

                  return <span className={style.awbActionsList} >

                    <Tooltip title="Delete airline">
                      <DeleteOutline onClick={() => this.deleteUserAirline(airline.id)} />
                    </Tooltip>
                  </span>;
                }
              }
            ]}

            data={this.state.userAirlines}

            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
                },
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
              filtering: true,
            }}
          />
        </div>
        <div style={{marginTop: 30, display: 'flex', justifyContent: 'flex-end'}}>
          <Button
            color="primary"
            variant="contained"
            onClick={this.props.handleClose}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(AirlineRepModal));
